import * as Yup from 'yup';

export const validateSchema = Yup.object().shape({
    expired_at: Yup.string().required().matches(/^\d{2}\.\d{2}\.\d{4}$/),
    balance: Yup.number().required().min(0),
    name: Yup.string().required()
});